import { getInsuranceType } from "../../../../../itrust_common/components/HelperFunctions";
import Toastr from "../../../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  saving: false,
  savingServiceIds: [],
  verify: false,
  detailViewPopup: { visible: false },
  eligibility: {},
  eligibilityProcessing: {},
  services: [],
  service: {},
  editing: {},
}

let changes = null

const serviceSavingState = (savingServiceIds) => ({
  savingServiceIds,
  saving: savingServiceIds.length > 0,
})

const setServiceSaving = (state, id, isSaving) => {
  if (id == null) return {}
  const savingServiceIds = (state.savingServiceIds || []).filter(existingId => existingId != id)
  if (isSaving) savingServiceIds.push(id)
  return serviceSavingState(savingServiceIds)
}

export const eligibilityProcessingKey = (patientId, insuranceType) => {
  if (patientId == null || patientId === '' || !insuranceType) return null
  return `${patientId}:${insuranceType}`
}

export const visionInsuranceReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'VISION_INSURANCE_SERVICES_LOAD_PENDING':
      return { ...state, saving: true };

    case 'VISION_INSURANCE_SERVICE_UPDATE_PENDING':
      return { ...state, ...setServiceSaving(state, action.meta?.id, true) };

    case 'VISION_INSURANCE_SERVICES_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, saving: (state.savingServiceIds || []).length > 0 };

    case 'VISION_INSURANCE_SERVICE_UPDATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, ...setServiceSaving(state, action.meta?.id, false) };

    case 'VISION_INSURANCE_CREDENTIAL_PROCESSING': {
      const services = state.services.map(service => {
        if (service.id !== action.data.id) return service
        return {
          ...service,
          credentialRequestPending: true,
          config: {
            ...service.config,
            creds: { ...service.config.creds, status: 'processing', message: '' }
          }
        }
      })
      return { ...state, services, ...setServiceSaving(state, action.data.id, true) }
    }

    case 'VISION_INSURANCE_CREDENTIAL_RETRY_FAILED': {
      const service = action.data.service
      const services = state.services.map(item => item.id === service.id ? service : item)
      return { ...state, services, ...setServiceSaving(state, service.id, false) }
    }

    case 'VISION_INSURANCE_SERVICE_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        services: state.services.map(item => item.id === response.add_on.id ? response.add_on : item),
        ...setServiceSaving(state, response.add_on.id, response.add_on?.config?.creds?.status === 'processing')
      }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_SERVICE_LOAD_FULFILLED': {
      const addOn = response.add_on
      if (!addOn) return state
      const current = state.services.find(item => item.id === addOn.id)
      if (current?.credentialRequestPending && addOn.config?.creds?.status !== 'processing') return state
      const services = state.services.map(item => item.id === addOn.id ? addOn : item)
      return { ...state, services, ...setServiceSaving(state, addOn.id, addOn.config?.creds?.status === 'processing') }
    }

    case 'VISION_INSURANCE_SERVICE_VALIDATION_TIMEOUT': {
      const services = state.services.map(service => {
        if (service.id !== action.data.id) return service
        return {
          ...service,
          config: {
            ...service.config,
            creds: { ...service.config.creds, status: 'failed', message: 'Credential validation timed out.' }
          }
        }
      })
      return { ...state, services, ...setServiceSaving(state, action.data.id, false) }
    }

    case 'VISION_INSURANCE_SERVICES_LOAD_FULFILLED': {
      const addOns = response.add_ons || []
      const returnedIds = new Set(addOns.map(service => String(service.id)))
      const processingIds = addOns
        .filter(service => service.config?.creds?.status === 'processing')
        .map(service => service.id)
      const inFlightIds = (state.savingServiceIds || []).filter(id => !returnedIds.has(String(id)))
      changes = {
        services: addOns,
        rpa_addon_id: addOns[0]?.id,
        ...serviceSavingState([...processingIds, ...inFlightIds])
      }
      return { ...state, ...changes };
    }

    case 'VISION_INSURANCE_EDIT':
      changes = { editing: { ...state.editing, ...action.data } }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_EDIT_RESET':
      changes = { editing: {} }
      return { ...state, ...changes };


    // verify
    case 'VISION_INSURANCE_ELIGIBILITY_PROCESSING': {
      const { processingKey, logId } = action.data || {}
      if (!processingKey) return state
      return {
        ...state,
        verify: true,
        eligibilityProcessing: { ...(state.eligibilityProcessing || {}), [processingKey]: logId || true }
      }
    }

    case 'VISION_INSURANCE_ELIGIBILITY_PROCESSING_DONE': {
      const eligibilityProcessing = { ...(state.eligibilityProcessing || {}) }
      if (action.data?.processingKey) delete eligibilityProcessing[action.data.processingKey]
      return { ...state, verify: Object.keys(eligibilityProcessing).length > 0, eligibilityProcessing }
    }

    case 'VISION_INSURANCE_ELIGIBILITY_VERIFY_PENDING':
      return { ...state, verify: true };

    case 'VISION_INSURANCE_ELIGIBILITY_VERIFY_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      if (response.data.status_code !== 500) {
        changes = { verify: false }
      }
      else {
        changes = { verify: false, eligibility: { ...state.eligibility, [getInsuranceType(response.data.insurance_type)]: { ...response.data } } }
      }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_ELIGIBILITY_VERIFY_FULFILLED':
      if (response.rpa_vision_insurance_log?.eligibility_status?.status === 'processing') {
        return { ...state, verify: true }
      }
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { verify: false, eligibility: { ...state.eligibility, [getInsuranceType(response.rpa_vision_insurance_log.insurance_type)]: { ...response.rpa_vision_insurance_log, success: true } } }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_ELIGIBILITY_POLL_RESULT': {
      const log = action.data
      const eligibilityStatus = log?.eligibility_status?.status
      const insuranceKey = getInsuranceType(log?.insurance_type)
      if (eligibilityStatus === 'found') {
        Toastr.handleShow(true, 'Claim Eligibility Is Generated Successfully', 201)
        return { ...state, verify: false, eligibility: { ...state.eligibility, [insuranceKey]: { ...log, success: true } } }
      }
      if (eligibilityStatus === 'not_found') {
        const error = log.eligibility_status?.error_message
        Toastr.handleShow(false, error, 500)
        return { ...state, verify: false, eligibility: { ...state.eligibility, [insuranceKey]: { ...log, success: false, error } } }
      }
      return state
    }

    case 'VISION_INSURANCE_ELIGIBILITY_POLL_FAILED':
      Toastr.handleShow(false, action.data.error, 500)
      return {
        ...state,
        verify: false,
        eligibility: {
          ...state.eligibility,
          [action.data.insuranceTypeKey]: { success: false, error: action.data.error }
        }
      }

    case 'VISION_INSURANCE_DETAIL_VIEW':
      changes = { detailViewPopup: { ...state.detailViewPopup, ...action.data } }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_ELIGIBILITY_EDIT':
      changes = { eligibility: { ...state.eligibility, ...action.data } }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_ELIGIBILITY_RESET':
      changes = { eligibility: {} }
      return { ...state, ...changes };

    default:
      return state
  }
}